import { NEW_NOTIFICATION, STATE_NOTIFICATION } from "../actions/notificationsActions";

import { states } from "./queriesStates";

const initialState = {
  notifications: [],
  errors: null,
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_NOTIFICATION: {
      return Object.assign({}, state, {
        notifications: state.notifications.concat(action.data),
      });
    }

    case STATE_NOTIFICATION: {
      return Object.assign({}, state, {
        notifications: state.notifications.map((notification) => {
          if (notification.id === action.id) {
            notification.state = action.state;
          }

          return notification;
        }),
      });
    }

    default:
      return state;
  }
};

export default notificationsReducer;
